export default __webpack_public_path__ + "4aa14f18e69d76df54608077034fb48a.png";